import React from 'react';
import { Button, ButtonSize, ButtonType, FillType } from 'views/components/atoms/button';
import { TransitionButton } from 'views/components/atoms/transitionButton';
import { Guidances } from 'views/components/atoms/guidances';
import { Toast } from 'views/components/atoms/toast';
import { PageStep, useReissuePassword } from './hook';
import { ErrorMessage } from 'formik';
import { SendSMSTemplate } from 'views/components/templates/sendSMS';

export const ReissuePassword = () => {
  const { formik, pageStep, toastProps, certificatePage } = useReissuePassword();

  return (
    <>
      {pageStep === PageStep.INPUT_INFO && (
        // 送信
        <form onSubmit={formik.handleSubmit} className="loginWrapper">
          <Guidances label="パスワード再発行手続きのため2段階認証を行ってください" />

          <div className="fieldWrapper">
            <div className="loginInput">
              <span className="loginInput_label">口座番号（ハイフンあり）</span>
              <input
                className="loginInput_field"
                name="account"
                value={formik.values.account}
                onChange={formik.handleChange}
              />
              {formik.errors.account ? <div className="errorRed">{formik.errors.account}</div> : null}
            </div>

            <div className="loginInput">
              <span className="loginInput_label">携帯電話番号</span>
              <input
                className="loginInput_field"
                type="tel"
                name="phoneNumber"
                value={formik.values.phoneNumber}
                onChange={formik.handleChange}
              />
              {formik.errors.phoneNumber ? <div className="errorRed">{formik.errors.phoneNumber}</div> : null}
            </div>
          </div>

          <div className="fieldWrapper">
            <Button
              label="認証コードを送信"
              type={ButtonType.Submit}
              fillType={FillType.primaryFill}
              buttonSize={ButtonSize.sizeM}
            />
          </div>

          <Toast {...toastProps} />
        </form>
      )}
      {pageStep === PageStep.CERTIFIBATE && <SendSMSTemplate {...certificatePage} toastProps={toastProps} />}
      {pageStep === PageStep.FIN && (
        // 完了
        <div className="loginWrapper">
          <Guidances label="登録されているメールアドレスに再設定パスワードをお送りしました" />

          <div className="fieldWrapper">
            <TransitionButton
              to="/"
              label="TOPへ戻る"
              type={ButtonType.Submit}
              fillType={FillType.primaryFill}
              buttonSize={ButtonSize.sizeM}
            />
          </div>
        </div>
      )}
    </>
  );
};
